import { createComponent as _$createComponent } from "@opentui/solid";
import { DialogPrompt } from "@tui/ui/dialog-prompt";
import { useDialog } from "@tui/ui/dialog";
import { useSync } from "@tui/context/sync";
import { createMemo } from "solid-js";
import { useSDK } from "../context/sdk";
export function DialogSessionRename(props) {
  const dialog = useDialog();
  const sync = useSync();
  const sdk = useSDK();
  const session = createMemo(() => sync.session.get(props.session));
  return _$createComponent(DialogPrompt, {
    title: "Rename Session",
    get value() {
      return session()?.title;
    },
    onConfirm: value => {
      sdk.client.session.update({
        sessionID: props.session,
        title: value
      });
      dialog.clear();
    },
    onCancel: () => dialog.clear()
  });
}